import React, { Component } from "react";
import { Api } from "../utils/api";
import Grid from "@material-ui/core/Grid";
import VisitsListTable from "./visits_list_table.component";
import CircularProgress from "@material-ui/core/CircularProgress";
import { VisitsFilterForm } from "./visits.filter.form";
import moment from "moment";

class VisitsList extends Component {
  constructor() {
    super();
    this.api = new Api();
    this.getUserRole = this.getUserRole.bind(this);
    this.initialSearch = this.initialSearch.bind(this);
    this.searchVisits = this.searchVisits.bind(this);
  }

  componentDidMount() {
    this.getUserRole().then(() => this.initialSearch());
  }

  state = {
    visits: null,
    administrator: false,
    userRole: null,
  };

  // obter o role do user logado
  getUserRole = async () => {
    await this.api
      .get(`/admins/${localStorage.id}`, {}, true)
      .then(({ data: admin }) => {
        this.setState({ userRole: admin.id_group });
      });
  };

  //pesquisa inicial de visitas marcadas, on load
  initialSearch = () => {
    let establishment_valence = "";
    let since = moment().format("YYYY-MM-DD");
    let until = moment().add(1, "day").format("YYYY-MM-DD");
    let filter_type = "visit_time";
    if (
      this.state.userRole === 2 || // grupos de admins
      JSON.parse(localStorage.id || null) === 9  || // joana oliveira
      JSON.parse(localStorage.id || null) === 5  || // ricardo pereira
      JSON.parse(localStorage.id || null) === 74 || // Marta Rodrigues
      JSON.parse(localStorage.id || null) === 66 // filipa meireles
    ) {
      this.setState({ administrator: true });
      let social_worker = 0;
      this.searchVisits(
        social_worker,
        establishment_valence,
        since,
        until,
        filter_type
      );
    } else {
      let social_worker = localStorage.id;
      this.searchVisits(
        social_worker,
        establishment_valence,
        since,
        until,
        filter_type
      );
    }
  };

  //obter marcações de visitas
  searchVisits(
    social_worker,
    establishment_valence,
    since,
    until,
    filter_type
  ) {
    this.setState({ visits: "" });
    let s_worker =
      social_worker === "" && this.state.administrator === true
        ? 0
        : social_worker !== "" && this.state.administrator === true
        ? social_worker
        : localStorage.id;
    this.api
      .get("/visits", {
        social_worker: s_worker,
        establishment_valence: establishment_valence,
        since: since,
        until: until,
        filter_type: filter_type,
      })
      .then(({ data = null }) => {
        this.setState({ visits: data });
      });
  }

  render() {
    return (
      <>
        <Grid container>
          <Grid item md={12} className="ml-4 mr-4">
            <VisitsFilterForm
              searchVisits={this.searchVisits}
              administrator={this.state.administrator}
            />
          </Grid>
        </Grid>

        {this.state.visits ? (
          <VisitsListTable visits={this.state.visits} />
        ) : (
          <div className="mt-4 ml-4 pt-4">
            <CircularProgress color="primary" />{" "}
          </div>
        )}

        {this.state.visits && (
          <Grid container>
            <Grid item md={12}>
              <div className="ml-4 mb-4 text-secondary">
                {this.state.visits === ""
                  ? "Sem visitas marcadas"
                  : this.state.visits.length === 1
                  ? "1 resultado"
                  : this.state.visits.length + " resultados"}
              </div>
            </Grid>
          </Grid>
        )}
      </>
    );
  }
}

export default VisitsList;
